var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99878 17.2515V21.0015H6.74878L17.8088 9.94152L14.0588 6.19152L2.99878 17.2515ZM20.7088 7.04152C21.0988 6.65152 21.0988 6.02152 20.7088 5.63152L18.3688 3.29152C17.9788 2.90152 17.3488 2.90152 16.9588 3.29152L15.1288 5.12152L18.8788 8.87152L20.7088 7.04152Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e55be0f4b489ca31c5f64805296e8c59.svg";
export { ForwardRef as ReactComponent };